import ErrorActionsEnums from './ErrorActionsEnums'

export const openDialogErrorAction = (errorMessage, errorStatus) => {
    return dispatch => {
        dispatch({
            type: ErrorActionsEnums.ERROR_OPEN_MODAL,
            errorMessage,
            errorStatus
        });
    };
};

export const closeDialogErrorAction = () => {
    return dispatch => {
        dispatch({type: ErrorActionsEnums.ERROR_CLOSE_MODAL});
    };
};



// WEBPACK FOOTER //
// ./src/store/error/ErrorActions.js